<template>
  <sFormItem
    v-if="value"
    :ref="propName"
    label=""
    :prop="propName">
    <div
      class="date-time__row">
      <div>
        <div class="sFormItem__label">
          {{ datelabel }}
        </div>
        <sPopover
          ref="popoverDate"
          placement="bottom"
          trigger="click"
          width="auto"
          @hide="saveDate(value.date)">
          <div
            slot="reference"
            class="date-time__chip"
            data-qa="date_chip">
            <template v-if="!value.dateStr">
              {{ $i18n.locale === 'en' ? '__/__/____' : '__.__.____' }}
            </template>
            <template v-else>
              {{ value.dateStr }}
            </template>
          </div>
          <v-date-picker
            ref="datePicker"
            :allowed-dates="allowedDates"
            class="elevation-0 calendar date_picker main__light_green"

            color="var(--v-secondary__green_not_active-base)"
            first-day-of-week="1"
            :locale="$i18n.locale"
            :min="dateMin"
            no-title
            scrollable
            show-current
            :value="value.date"
            @input="saveDate"/>
        </sPopover>
      </div>
      <div>
        <div class="sFormItem__label">
          {{ timeLabel }}
        </div>
        <sPopover
          ref="popoverTime"
          placement="bottom"
          trigger="click"
          width="auto"
          @hide="saveTime(value.time)">
          <div
            slot="reference"
            class="date-time__chip"
            data-qa="time_chip">
            {{ value.timeStr ? value.timeStr : '' }}
          </div>
          <v-time-picker
            ref="timePicker"
            class="date-time-row__time"
            color="var(--v-secondary__green_not_active-base)"
            format="24hr"
            full-width
            :locale="$i18n.locale"
            :max="timeMax"
            :min="timeMin"
            :value="value.time"
            @change="saveTime"
            @click:minute="saveTime"/>
        </sPopover>
      </div>
    </div>
  </sFormItem>
</template>
<script>
export default {
  name: 'DateTimeRow',
  computed: {
    allowedDates() {
      return (date) => {
        const day = new Date(date).getDay()
        return day !== 0 && day !== 6
      }
    }
  },
  methods: {
    sendEvent(result) {
      this.$emit('update:value', result)
      this.$nextTick(() => {
        this.$refs.popoverDate.showPopper = false
        this.$refs.popoverTime.showPopper = false
        this.$refs.timePicker.selecting = 1
        this.$refs[this.propName]?.$emit.apply(this.$refs[this.propName], ['s.form.change'].concat(result))
      })
    },
    getTwoSymbol(value) {
      value = value || 0
      return value < 10 ? `0${value}` : value
    },
    saveDate(value) {
      if (this.$refs.datePicker) {
        const day = this.getTwoSymbol(this.$refs.datePicker?.inputDay)
        const month = this.getTwoSymbol(this.$refs.datePicker?.inputMonth + 1)
        const year = this.getTwoSymbol(this.$refs.datePicker?.inputYear)
        value = `${year}-${month}-${day}`
      }

      const result = this.$_.cloneDeep(this.value)
      result.date = value
      result.dateTime = `${value}T${result.time || '00:00:00'}`

      this.sendEvent(result)
    },
    saveTime(value) {
      if (this.$refs.timePicker) {
        const hour = this.getTwoSymbol(this.$refs.timePicker?.inputHour)
        const minute = this.getTwoSymbol(this.$refs.timePicker?.inputMinute)
        value = `${hour}:${minute}`
      }

      const result = this.$_.cloneDeep(this.value)
      result.time = value
      const date = result.date || new Date().toISOString().split('T')[0]
      result.dateTime = `${date}T${value}`

      this.sendEvent(result)
    }
  },
  props: {
    value: Object,
    datelabel: String,
    timeLabel: String,
    propName: String,
    timeMax: {
      type: String,
      default: '23:59:59'
    },
    timeMin: {
      type: String,
      default: '00:00:00'
    },
    dateMax: {
      type: String,
    },
    dateMin: {
      type: [String, Date],
    },
  },
}
</script>
<style lang="scss" scoped>
.sFormItem.is-error .date-chip {
  border-color: var(--color-error) !important;
}

.date-time {
 &__row {
  display: grid;
  gap: 24px;
  grid-template-columns: auto auto;
 }
 &__chip {
  cursor: pointer;
  min-height: 40px;
  height: 40px;
  border-radius: 31px;
  background: var(--white-color) !important;
  border: 2px solid var(--color-main-green);
  padding: 11px 15px;
  line-height: 18px;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: var(--text-color);
 }
}
</style>
<style lang="scss">
.sFormItem.is-error>.sFormItem__content>.date-time__row .date-time__chip {
  border-color: var(--color-error);
}
.date-time-row__time {
 .v-time-picker-clock {
  background: none !important;
  background: var(--v-secondary__green_chosen-base);
 }
 .v-picker__body {
  background-color: var(--v-main__light_green-base) !important;
 }
}
</style>
